import http from "@/utils/http";

// 分页查询
export function gainList(data) {
  return http({
    url: "/user/projects",
    method: "GET",
    params: data,
  });
}
// 查看指定学生的作品
export function getStudentWorksList(id, data) {
  return http({
    url: "/user/projects/" + id,
    method: "GET",
    params: data,
  });
}

//  创建作品
export function createProject(data) {
  return http({
    url: "/user/project/add",
    method: "POST",
    data
  });
}

//  复制作品
export function copyProject(data) {
  return http({
    url: "/user/project/copy" + data,
    method: "POST"
  });
}

//  查看作品详情
export function lookProjectInfo(data) {
  return http({
    url: "/user/project/detail?projectid=" + data,
    method: "GET"
  });
}

//  删除作品
export function delProject(data) {
  return http({
    url: "/user/project/delete/" + data,
    method: "POST"
  });
}

//   编辑作品
export function editProject(id, data) {
  return http({
    url: "/user/project/update/" + id,
    method: "POST",
    data
  });
}

//  发布作品/修改发布信息/修改
export function releaseProject(data) {
  return http({
    url: "/user/project/update",
    method: "POST",
    data
  });
}

//   取消作品发布
export function cancelProject(data) {
  return http({
    url: "/user/project/close/" + data,
    method: "POST"
  });
}

//   本周最火
export function hotProject(data) {
  return http({
    url: "/user/open/projects/hot" + data,
    method: "GET"
  });
}

//   最近最火
export function latestProjects(data) {
  return http({
    url: "/user/open/projects/latest" + data,
    method: "GET"
  });
}

//   搜藏/取消搜藏
export function favorProjects(data) {
  return http({
    url: "/user/project/favor/" + data,
    method: "POST"
  });
}

//   点赞 / 取消点赞;
export function praisePOST(data) {
  return http({
    url: "/user/project/praise/" + data,
    method: "POST"
  });
}

//   评论作品或者 回复评论
export function commentProjects(data) {
  return http({
    url: "/user/project/comment",
    method: "POST",
    data
  });
}

//   分页查询作品评论
export function commentsProjects(data) {
  return http({
    url: "/user/project/comments" + data,
    method: "GET"
  });
}
